import React from 'react';
import { Card } from '../ui/Card';
import { WeeklyStats } from '../../utils/activityHelpers';
import { Target, Zap, Award } from 'lucide-react';
interface WeeklyHighlightsProps {
  stats: WeeklyStats;
}
export function WeeklyHighlights({
  stats
}: WeeklyHighlightsProps) {
  return <Card className="p-6 border-emerald-100" data-id="element-4184">
      <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-4185">
        <Zap className="w-5 h-5 text-amber-500" data-id="element-4186" />
        Deze week
      </h3>

      <div className="space-y-4" data-id="element-4187">
        <div className="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4188">
          <div className="flex items-center gap-3" data-id="element-4189">
            <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center" data-id="element-4190">
              <Target className="w-5 h-5" data-id="element-4191" />
            </div>
            <span className="font-bold text-slate-700" data-id="element-4192">Vragen beantwoord</span>
          </div>
          <span className="text-xl font-black text-emerald-600" data-id="element-4193">
            {stats.totalQuestions}
          </span>
        </div>

        {stats.bestModuleId && <div className="flex items-center justify-between p-3 bg-slate-50 rounded-xl border border-slate-100" data-id="element-4194">
            <div className="flex items-center gap-3" data-id="element-4195">
              <div className="w-10 h-10 rounded-full bg-indigo-100 text-indigo-600 flex items-center justify-center text-xl" data-id="element-4196">
                {stats.bestModuleIcon}
              </div>
              <div data-id="element-4197">
                <div className="font-bold text-slate-700" data-id="element-4198">Meest geoefend</div>
                <div className="text-xs text-slate-500" data-id="element-4199">
                  {stats.bestModuleTitle}
                </div>
              </div>
            </div>
            <span className="text-xl font-black text-indigo-600" data-id="element-4200">
              {stats.bestModuleCount}x
            </span>
          </div>}
      </div>
    </Card>;
}